import { useCallback, useState, type ReactNode } from "react";

import { ConfirmationDialog } from "@skilitics/designer-ui-components";
import type { FormatMessages } from "@skilitics/localization";
import { useFormatMessage } from "@skilitics/localization";

export const useConfirmedAction = () => {
  const formatMessage = useFormatMessage(formatStrings);
  const [dialog, setDialog] = useState<ReactNode>();

  const confirmAction = useCallback(
    (header: string, onConfirm: () => void) => {
      const onClose = () => setDialog(undefined);

      setDialog(
        <ConfirmationDialog
          header={header}
          message={formatMessage("confirmation")}
          open
          confirmLabel={formatMessage("confirm")}
          cancelLabel={formatMessage("cancel")}
          onConfirm={(confirmed) => {
            if (confirmed) onConfirm();
            onClose();
          }}
        />,
      );
    },
    [formatMessage],
  );

  return { confirmAction, confirmationDialog: dialog };
};

const formatStrings = {
  cancel: {
    en: "Cancel",
  },
  confirm: {
    en: "Confirm",
  },
  confirmation: {
    en: "This action cannot be undone. Do you wish to proceed?",
  },
} satisfies FormatMessages;
